import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BsTrash } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import playerImage from "../../assests/indiaImages/player.jpeg";
import { endPoints, sportEndPoint } from "../../constant/Environment";
import { Actions } from "../../redux/Actions/Actions";
import { addBetData, getAllData } from "../../Utility/API";
import { checkGeoAndVpn } from "../../Utility/functions/Helper";
import Loader from "../Loader";
import { useSnackbarContext } from "../SnackbarContext";
import GeoVpnError from "../GeoVpnError";

const NewPlayerBetSlip = () => {
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
  const state = useSelector((state) => state);
  const { selectedBetslipBtn } = state.betslip;
  const betslipLength = state.betslip.betslips.length;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoadinig] = useState(false);
  const [teamSize, setTeamSize] = useState(0);
  const [showGeoVpnError, setShowGeoVpnError] = useState(false);

  const maxPlayers = 5;
  const totalCredits = 100;

  const progressTotal =
    teamSize > 0
      ? Math.min(100, Math.round((betslipLength / teamSize) * 100))
      : 0;
  const handleRemoveBetslip = (item) => {
    dispatch({
      type: Actions.REMOVE_SELECTED_BETSLIP,
      data: item.playerId,
    });
  };

  const SubmitTeam = async () => {
    // if(state?.betslip?.pooldata?.price > state?.auth?.user?.balance){
    //   showErrorSnackbar("Your Balance is not sufficeint please depsoit to play.");
    //   return;
    // }
    
    setIsLoadinig(true);
    
    try {
      // Check geo location and VPN before submitting
      const geoResult = await checkGeoAndVpn(dispatch);
      
      if (geoResult) {
        // User is in restricted area or using VPN - show modal
        setIsLoadinig(false);
        setShowGeoVpnError(true);
        return;
      }
      
      // Proceed with team submission if geo check passes
      const url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.TEAM_BET}`;
      const data = {
        id: 0,
        userId: state?.auth?.user?.idUser,
        eventId: state.betslip.eventId,
        poolPrice: state?.betslip?.pooldata?.price,
        eventDate: "",
        sessionId: state?.auth?.user?.sessionId,
        accountId: state?.auth?.user?.idUser,
        players: state.betslip.betslips,
        poolId: state?.betslip?.pooldata?.id,
      };
      const response = await addBetData(url, data);
      if (response?.data?.status == "success") {
        dispatch({
          type: Actions.REMOVE_ALL_BETSLIP,
        });
        GetUserById();
        showSuccessSnackbar("Your Team has been created! Play more");
        navigate("/");
      } else {
        showErrorSnackbar(response?.data?.message);
      }
    } catch (err) {
      showErrorSnackbar(
        "Issue connecting to server (error code 15). Please contact support for further assistance."
      );
      console.log("Err", err);
    } finally {
      setIsLoadinig(false);
    }
  };  const GetUserById = () => {
    let url = `${endPoints.api.GET_BY_USERID}/${state?.auth?.user?.idUser}`;
    getAllData(url).then((response) => {
      dispatch({
        type: Actions.LOGIN,
        data: { user: response.data },
      });
    });
  };

  useEffect(() => {
    if (state.betslip.betslips.length > 0) {
      const ts = state.betslip.betslips[0].teamSize;
      setTeamSize(ts);
    }
  }, [state.betslip.betslips]);

  return (
    <>
      {isLoading && <Loader visible={isLoading} />}
      <Paper sx={{ padding: 2, borderRadius: 2, boxShadow: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} sx={{ width: "100%" }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <Stack direction="row" spacing={1.25} alignItems="center">
                <EmojiEventsOutlinedIcon sx={{ color: "#C02640" }} />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "#C02640",
                      fontWeight: 700,
                      lineHeight: 1,
                      fontSize: "1rem",
                    }}
                  >
                    Team Selection 
                  </Typography>
                  {/* <Typography variant="caption" color="text.secondary">Choose exactly {teamSize || 0} players to enter.</Typography> */}
                </Box>
              </Stack>
              <Button
                size="small"
                variant="text"
                onClick={() => {
                  dispatch({ type: Actions.REMOVE_ALL_BETSLIP });
                }}
                
                sx={{ textTransform: "none", fontWeight: 600 }}
              >
                Clear All
              </Button>
            </Box>
          </Grid>

          <Box sx={{ width: "100%", mt: 0.5 }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              alignItems={{ xs: "stretch", sm: "center" }}
              justifyContent="space-between"
            >
              {/* <Stack direction="row" spacing={1} alignItems="center">
                <Chip label={`Selected: ${betslipLength}`} color="primary" variant="outlined" sx={{ fontWeight: 600 }} />
                <Chip label={`Required: ${teamSize || 0}`} variant="outlined" />
              </Stack> */}
              {betslipLength > 0 && (
                <Box sx={{ flex: 1, minWidth: 160 }}>
                  <LinearProgress
                    variant="determinate"
                    value={progressTotal}
                    sx={{ height: 8, borderRadius: 999 }}
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "0.75rem" }}
                  >
                    {betslipLength}/{teamSize || 0} selected
                  </Typography>
                </Box>
              )}
            </Stack>
          </Box>

          <Grid item xs={12} sx={{ width: "100%" }}>
            <Box display="flex" flexDirection="column" gap={2}>
              {state.betslip.betslips.map((player, index) => {
                return (
                  <React.Fragment key={player.playerId || index}>
                    <Paper
                      elevation={2}
                      sx={{
                        borderRadius: 2,
                        p: 1.5,
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        width: "100%",
                        border: "1px solid rgba(0,0,0,0.08)",
                        transition:
                          "transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease",
                        "&:hover": {
                          transform: "translateY(-1px)",
                          boxShadow: 4,
                          borderColor: "rgba(0,0,0,0.12)",
                        },
                        background:
                          "linear-gradient(180deg, #fff 0%, #fcfcff 100%)",
                        overflow: "hidden",
                      }}
                    >
                      {/* Accent bar */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: 4,
                          bgcolor: "#0ea5e9",
                        }}
                      />
                      {/* Delete icon top-right */}
                      <Tooltip title="Remove" arrow>
                        <IconButton
                          size="small"
                          sx={{ position: "absolute", top: 6, right: 6 }}
                          onClick={() => handleRemoveBetslip(player)}
                        >
                          <BsTrash />
                        </IconButton>
                      </Tooltip>
                      {/* Avatar with index chip */}
                      <Box sx={{ position: "relative" }}>
                        <Avatar
                          src={player.image ? player.image : playerImage}
                          alt={player.name}
                          sx={{
                            width: 56,
                            height: 56,
                            border: "2px solid #e7eaf3",
                          }}
                        />
                        <Chip
                          size="small"
                          label={`#${index + 1}`}
                          sx={{ position: "absolute", bottom: -10, left: 0 }}
                        />
                      </Box>
                      {/* Details */}
                      <Box sx={{ flexGrow: 1, ml: 1 }}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            lineHeight: 1.2,
                            fontWeight: 700,
                            color: "#0f2b46",
                            fontSize: "0.95rem",
                          }}
                        >
                          {player.name}
                        </Typography>
                        <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                          <Chip
                            size="small"
                            label={player.positionAbv || ""}
                            sx={{ bgcolor: "#eef6ff" }}
                          />
                        </Stack>
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="center"
                          sx={{ mt: 1 }}
                        >
                          {/* <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "text.secondary",
                              fontSize: "0.8rem",
                            }}
                          >
                            Points
                          </Typography> */}
                          <Chip
                            size="small"
                            color="info"
                            variant="outlined"
                            label={`${player.fantasypoint} Projected Points`}
                          />
                          <Chip
                            size="small"
                            label={player?.Team ? `${player.Team}` : ""}
                            variant="outlined"
                          />
                        </Stack>
                      </Box>
                    </Paper>
                    {/* <Divider sx={{ my: 0.5 }} /> */}
                  </React.Fragment>
                );
              })}
            </Box>
          </Grid>

          <Box sx={{ width: "100%", mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Review your selection and submit when ready.
            </Typography>
          </Box>

          {betslipLength > 0 && betslipLength == teamSize && (
            <Grid item xs={12} md={12} sx={{ width: "100%" }}>
              <Paper
                elevation={6}
                sx={{ position: "sticky", bottom: 8, p: 1, borderRadius: 2 }}
              >
                {state.auth?.isAuthenticated ? (
                  <Button
                    size="large"
                    fullWidth
                    sx={{
                      background: "rgb(23, 150, 36)",
                      color: "white",
                      textTransform: "capitalize",
                    }}
                    onClick={SubmitTeam}
                  >
                    Submit Team
                  </Button>
                ) : (
                  <Button
                    size="large"
                    fullWidth
                    sx={{
                      background: "rgb(23, 150, 36)",
                      color: "white",
                      textTransform: "capitalize",
                    }}
                    onClick={() => navigate("/login")}
                  >
                    <Typography
                      variant="body1"
                      sx={{ color: "white!important" }}
                    >
                      Login
                    </Typography>
                  </Button>
                )}
              </Paper>
            </Grid>
          )}
        </Grid>
      </Paper>
      
      {/* Geo/VPN Error Modal */}
      <GeoVpnError 
        show={showGeoVpnError} 
        onClose={() => setShowGeoVpnError(false)} 
      />
    </>
  );
};

export default NewPlayerBetSlip;
